YP.AdvertContainer = function() {

    var closeYurplanExperienceContainer = $('.c-advert__close');
    var yurplanExperienceContainer = $('#yurplanExperienceContainer');

    return {
        init: function() {

            closeYurplanExperienceContainer.on('click', function(e) {
                localStorage.setItem('yurplanExperienceContainer', 'hide');
                yurplanExperienceContainer.addClass('hide');
                yurplanExperienceContainer.removeClass('show');
            })
            if (localStorage.getItem('yurplanExperienceContainer') == 'hide') {
                yurplanExperienceContainer.addClass('hide');
                yurplanExperienceContainer.removeClass('show');
            }
            else {
                yurplanExperienceContainer.removeClass('hide');
                yurplanExperienceContainer.addClass('show');
            }
        }
    };
};

window.addEventListener("load", function(){
    if($('.c-advert').length >0 ) {
        YP.AdvertContainer().init();
    };
});
